import { useMutation } from "@tanstack/react-query";
import apiFastifyClient from "./apiFastifyClient";

interface IReqBody {
  ticketId: string;
  arsannRate: number;
  arsannComment: string;
  employeeRate: number;
  employeeComment: string;
}

export const useAddFeedbackMutation = () =>
  useMutation<void, any, IReqBody>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/feedback`, data);
    },
  });
